import React from 'react';

import { style, keyframes } from 'glamor';

const outer = style({
  overflow: 'hidden',
  width: '50%',
  height: 4,
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  borderRadius: 2,
});

const inner = style({
  position: 'relative',
  width: '100%',
  height: '100%',
});

const beforeAnimation = keyframes({
  '0%': { left: '-100%', width: '100%' },
  '100%': { left: '100%', width: '10%' },
});

const afterAnimation = keyframes({
  '0%': { left: '-150%', width: '100%' },
  '100%': { left: '100%', width: '10%' },
});

const loaderBefore = style({
  position: 'absolute',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  animation: `${beforeAnimation} 1.5s infinite ease-out`,
});

const loaderAfter = style({
  position: 'absolute',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  animation: `${afterAnimation} 1.5s infinite ease-out`,
});

export default () => (
  <div {...outer}>
    <div {...inner}>
      <div {...loaderBefore} />
      <div {...loaderAfter} />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ../src/client/components/loaders/Linear.js